export enum CheckboxValue {
  Active = 'Active',
  Indeterminate = 'Indeterminate',
  NotActive = 'Not Active'
}
